var modCheckoutPayment = function(){
    var scope = ".js-mod-checkout-payment";

    function showLoading(){
        var $page = $("body");
        $page.addClass("is-loading");

    }
    function hideLoading(){
        $("body").removeClass("is-loading");
    }

    ui.ready(
        scope,
        function($mod){
            var amount;
            var $showCartButton = $mod.find(scope+"__show-cart-detail");
            var $paypalButtonDiv = $mod.find(scope+"__paypal-button-container");
            $paypalButtonDiv.hide();
            var selectedPaymentType = $mod.find(scope+"__payment-type.is-selected").eq(0).data("id");;

            $showCartButton.click(
                function(ev){
                    ev.preventDefault();
                    var $cartModalBody = $mod.find(scope+"__create-address-modal-body");
                    gvf.endpoint(
                        "web\\shopProcessController::showViewCartDetail",
                        null,
                        function(response){
                            if(response){
                                var $cartModal = $mod.find(scope+"__create-cart-modal").clone();
                                ui.init($cartModal);
                                var $cartModalBody = $cartModal.find(scope+"__create-cart-modal-body");
                                $cartModalBody.empty();
                                $cartModal.find("#createCartModalTitle").text("Resumen del pedido");
                                $cartModalBody.append(response.html);
                                ui.init($cartModalBody);
                                $cartModal.modal('show');

                            }else{
                                utils.alertEndpointResponse(response);
                            }
                        }
                    );
                }
            );

            if(window.ApplePaySession && ApplePaySession.canMakePayments("merchant.com.drink6.apple-redsys")){

                $mod.find(scope+"__payment-type-10").show();
            }

            var $confirmButton = $mod.find(scope+"__confirm-step");

            $mod.find(scope+"__payment-type").click(
                function(ev){
                    ev.preventDefault();
                    $(this).addClass("is-selected").siblings().removeClass("is-selected");
                    var paymentType = $mod.find(scope+"__payment-type.is-selected").eq(0).data("id");
                    if(paymentType==13 || paymentType==2){
                        if($mod.find("[name=accept_terms]").is(":checked")){
                            window.location.href = window.location.pathname+"?pay="+paymentType;
                        }else{
                            $(this).removeClass("is-selected");
                            gvf.endpoint(
                                "web\\shopProcessController::getLangConditionTextPaypal",
                                null,
                                function(response){
                                    if(response){
                                        Swal.fire(
                                            {
                                                icon: "error",
                                                text: response
                                            }
                                        );
                                    }
                                }
                            );
                        }
                    }else{
                        if(paymentType){
                            window.location.href = window.location.pathname+"?pay="+paymentType;
                        }
                    }
                }
            );

            var urlParams = new URLSearchParams(window.location.search);
            //get payment type id
            var paymentTypeUrlParam = urlParams.get('pay');
            if(paymentTypeUrlParam){
                getIssuers(paymentTypeUrlParam);
            }

            function getIssuers(paymentTypeId){
                if(paymentTypeId && !isNaN(paymentTypeId)){
                    gvf.endpoint(
                        "web\\shopPaymentController::getIssuers",
                        [paymentTypeId],
                        function (response) {
                            var issuersBlock = $mod.find(scope+"__payment-type[data-id='"+paymentTypeId+"'] "+scope+"__issuers");
                            if(response && issuersBlock && issuersBlock.length>0){
                                issuersBlock.html(response);
                                ui.init(issuersBlock);
                                issuersBlock.click(function(ev){
                                    ev.preventDefault();
                                    ev.stopPropagation();
                                });
                            }
                        }
                    );
                }
            }

            function getApplePayRequest(){
                var request = {
                    "countryCode": $mod.attr("data-country-code").toUpperCase(),
                    "currencyCode": "EUR",
                    "merchantCapabilities": [
                        "supports3DS",
                        "supportsDebit",
                        "supportsCredit"
                    ],
                    "supportedNetworks": [
                        "visa",
                        "masterCard",
                        "amex",
                        "discover"
                    ],
                    "total": {
                        "label": "DRINK 6",
                        "amount": amount,
                        "type": "final"
                    }
                };

                // Create ApplePaySession
                var session = new ApplePaySession(1,request);

                session.onvalidatemerchant = function(event){
                    console.log(event);

                    gvf.endpoint(
                        "web\\shopProcessController::requestApplePay",
                        [event.validationURL],
                        function(response){
                            console.log(response);
                            session.completeMerchantValidation(response);
                        }
                    );
                };

                // onpaymentauthorized: A callback function that is automatically called when an Apple Pay payment has been authorized.
                session.onpaymentauthorized = function(event){
                    console.log("starting session.onpaymentauthorized");
                    console.log(event);
                    var promise = sendPaymentToken(event.payment.token);
                    promise.then(function(success){
                        var status;
                        if(success){
                            status = ApplePaySession.STATUS_SUCCESS;
                            console.log("Apple Pay Payment SUCCESS ");
                        }else{
                            status = ApplePaySession.STATUS_FAILURE;
                        }
                        console.log("result of sendPaymentToken() function =  "+success);
                        session.completePayment(status);
                    });
                };

                function sendPaymentToken(paymentToken){
                    return new Promise(function(resolve,reject){
                        console.log("starting function sendPaymentToken()");
                        console.log(paymentToken);
                        processPayment(paymentToken.paymentData,function(resp){
                            if(resp){
                                resolve(true);
                            }else{
                                reject;
                            }
                        });
                    });
                }

                session.oncancel = function(event){
                    console.log("starting session.cancel");
                    console.log(event);
                };

                session.begin();
            }

            function promisePrice(){
                return new Promise(function(resolve,reject){
                    getAmount(function(resp){
                        if(resp){
                            resolve(resp);
                        }else{
                            reject;
                        }
                    });
                });
            }

            function getAmount(callback){
                gvf.endpoint(
                    "web\\shopProcessController::getTotalAmountApplePay", 
                    null,
                    function(resp){
                        if(resp.status==="ok"){
                            amount = resp.amount;
                            callback(amount);
                        }
                    });
            }

            function processPayment(paymentData,callback){
                $confirmButton.prop("disabled",true).addClass("is-disabled");
                var selectedPaymentType = $mod.find(scope+"__payment-type.is-selected").eq(0).data("id");
                var paymentMethodIssuer = "";
                var paymentMethodIssuerField = $mod.find("[name=payment_method_issuer]");
                if(paymentMethodIssuerField && paymentMethodIssuerField,length>0){
                    paymentMethodIssuer = paymentMethodIssuerField.closest(".js-form-field").formFieldVal();
                }
                gvf.endpoint(
                    "web\\shopProcessController::confirmStep",
                    [$mod.data("step"),{
                        "payment_type_id": selectedPaymentType,
                        "accept_terms": $mod.find("[name=accept_terms]").is(":checked"),
                        "enable_promos": $mod.find("[name=enable_promos]").is(":checked"),
                        "accept_private_policy": $mod.find("[name=accept_private_policy]").is(":checked"),
                        "paymentData": paymentData,
                        "payment_method_issuer":paymentMethodIssuer
                    }],
                    function(response){
                        $confirmButton.prop("disabled",false).removeClass("is-disabled");
                        if(response.status=="ok"){
                            if(response.stripe_multibanco){
                                if(0 && response.url){
                                    window.open(response.url,'_blank');
                                }
                                var stripe = Stripe(response.public_key,{locale: response.locale});
                                stripe.redirectToCheckout({
                                    sessionId: response.session_id
                                }).then(
                                    function(result){
                                        utils.alertEndpointResponse(result.error.message);
                                    }
                                );
                            }else if(response.url){
                                window.location = response.url;
                            }else if(response.html){
                                var $form = $(response.html);
                                $form.find("[name='__restrictions']").remove();
                                $("body").append($form);
                                $form.submit();
                                callback(true);
                            }else if(response.stripe){
                                var stripe = Stripe(response.public_key,{locale: response.locale});
                                stripe.redirectToCheckout({
                                    sessionId: response.session_id
                                }).then(
                                    function(result){
                                        utils.alertEndpointResponse(result.error.message);
                                    }
                                );
                            }else if(response.spgData && response.urlOk && response.urlCancel){
                                gvf.endpoint(
                                    "web\\shopProcessController::getMbWayForm",
                                    [response.spgData],
                                    function(resp){
                                        var $mbWayModal = $mod.find(scope+"__create-mb-way-modal").clone();
                                        var $mbWayModalBody = $mbWayModal.find(scope+"__create-modal-body");
                                        $mbWayModalBody.empty();
                                        $mbWayModalBody.append(resp.html);

                                        $mbWayModalBody.find(scope+"__create-mb-way-button").on("click",function(event){
                                            event.preventDefault();
                                            event.stopPropagation();
                                            $mbWayModalBody.find(scope+"__create-mb-way-button").prop("disabled",true).addClass("is-disabled");
                                            $mbWayModalBody.find(scope+"__create-mb-way-input").prop("disabled",true).addClass("is-disabled");
                                            var telephone =  $mbWayModalBody.find(scope+"__create-mb-way-input").val();
                                            var country =  $mbWayModalBody.find("[name=select]").val();

                                            if(telephone){
                                                gvf.endpoint(
                                                    "web\\shopProcessController::getMbWayIdPurchase",
                                                    [response.spgData, telephone,response.urlOk,response.urlCancel,country],
                                                    function(response){
                                                        if(response.status=="ok"){
                                                            var interval = setInterval(function(){
                                                                gvf.endpoint(
                                                                    "web\\shopProcessController::getPurchaseStatus",
                                                                    [response.transactionID,response.returnUrlOk,response.returnUrlCancel, response.orderId],
                                                                    function(getPurchaseStatusResp){
                                                                        if(getPurchaseStatusResp.status == "ok"){
                                                                            clearInterval(interval);
                                                                            window.location = getPurchaseStatusResp.returnUrl;
                                                                        }
                                                                        if(getPurchaseStatusResp.status == "ko"){
                                                                           clearInterval(interval);
                                                                            window.location = getPurchaseStatusResp.returnUrl;
                                                                        }
                                                                    }
                                                                );
                                                            },4000);
                                                        }else{
                                                            window.location = response.returnUrlCancel;
                                                        }
                                                    }
                                                );
                                            } else{
                                                $mbWayModalBody.find(scope+"__create-mb-way-button").prop("disabled",false).removeClass("is-disabled");
                                                $mbWayModalBody.find(scope+"__create-mb-way-input").prop("disabled",false).removeClass("is-disabled");

                                                utils.alertEndpointResponse("Introduce número de telefono");
                                            }
                                        });
                                        ui.init($mbWayModalBody);
                                        $mbWayModal.modal('show');
                                    }
                                );
                            }
                        }else{
                            if(response.url){
                                window.location = response.url;
                            }else{
                                utils.alertEndpointResponse(response);
                            }
                        }
                    }
                );
            }

            //Paypal new integration:
            if($mod.find(scope+"__payment-type.is-selected").length>0 && $mod.find(scope+"__payment-type.is-selected").eq(0).data("id")===13){
                $mod.find(scope+"__confirm-step").addClass('is-paypal');
                $paypalButtonDiv.removeClass('is-pay-general');
                $paypalButtonDiv.addClass('is-paylater');
                $mod.find("[name=accept_terms]").prop("checked",true);
                if($mod.find("[name=accept_private_policy]").length>0){
                    $mod.find("[name=accept_private_policy]").prop("checked",true);
                }
                $paypalButtonDiv.show();
            }
            if($mod.find(scope+"__payment-type.is-selected").length>0 && $mod.find(scope+"__payment-type.is-selected").eq(0).data("id")===2){
                $mod.find(scope+"__confirm-step").addClass('is-paypal');
                $paypalButtonDiv.removeClass('is-paylater');
                $paypalButtonDiv.addClass('is-pay-general');
                $mod.find("[name=accept_terms]").prop("checked",true);
                if($mod.find("[name=accept_private_policy]").length>0){
                    $mod.find("[name=accept_private_policy]").prop("checked",true);
                }
                $paypalButtonDiv.show();
            }
            if($mod.data('payments')){
                if(window.paypal){
                    paypal.Buttons({
                        // Order is created on the server and the order id is returned
                        createOrder: function (data, actions) {
                            return new Promise(function (resolve,reject){
                                gvf.endpoint(
                                    "web\\shopProcessController::confirmStepPaypal",
                                    [$mod.data("step"),{
                                        "payment_type_id": selectedPaymentType
                                    }],
                                    function (response) {
                                        if(response){
                                            resolve(response.resp.id);
                                        }else{
                                            utils.alertEndpointResponse(response);
                                            reject(response);
                                        }
                                    }
                                );
                            })
                        },
                        // Finalize the transaction on the server after payer approval
                        onApprove: function (data, actions) {
                            showLoading();
                            gvf.endpoint(
                                "web\\shopPaymentController::PaypalPaymentConfirm",
                                [data.orderID],
                                function (response) {
                                    hideLoading();
                                    if(response){
                                        window.location = response.url;
                                    }else{
                                        utils.alertEndpointResponse(response);
                                    }
                                }
                            )

                        }
                    }).render('#paypal-button-container');
                }
            }

            $confirmButton.click(
                function(ev){
                    ev.preventDefault();
                    if(selectedPaymentType===10){
                        if($mod.find("[name=accept_terms]").is(":checked")){
                            getAmount(function(resp){
                                amount = resp;
                                new swal({
                                    title: "Apple Pay",
                                    text: "Se ha elegido el método de pago Apple Pay, ¿Desea continuar?",
                                    type: "confirm",
                                    showCancelButton: true,
                                    confirmButtonColor: "#fc4b6c",
                                    confirmButtonText: "Pagar",
                                    cancelButtonText: "Elegir otro método de pago",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                }).then(
                                    function(isConfirm){
                                        if(isConfirm.isConfirmed){
                                            getApplePayRequest();
                                        }
                                    }
                                );
                            });
                        }else{
                            processPayment(null);
                        }
                    }else{
                        processPayment(null);
                    }
                }
            );
        }
    );
}();
